/**
 * Vario-iframe-Kommunikation (postMessage an den Vario-Parent).
 *
 * Spiegelt @vario-software/vario-app-framework-frontend (communication.js):
 * Nachrichten an window.parent tragen immer { appIdentifier, integrationId, ...payload }.
 * appIdentifier/integrationId kommen als URL-Query-Parameter vom Vario-Slot.
 */
function urlParam(name: string): string | undefined {
  return new URL(window.location.href).searchParams.get(name) ?? undefined;
}

export const varioAppIdentifier = urlParam('appIdentifier');
export const varioIntegrationId = urlParam('integrationId');

export function sendVarioMessage(payload: Record<string, unknown>): void {
  try {
    window.parent.postMessage(
      { appIdentifier: varioAppIdentifier, integrationId: varioIntegrationId, ...payload },
      '*',
    );
  } catch {
    // Top-Level geoeffnet (kein Parent) - ignorieren.
  }
}

/**
 * Standard-Hoehe (px) fuer das eingebettete go-returns-Backend. Vario bettet
 * mit Hoehe 0 ein und reicht die verfuegbare Hoehe NICHT durch (height.js postet
 * nur einseitig) -> ein kalibrierter Festwert. Das DashboardLayout ist h-screen
 * mit internem Scroll (`main` = overflow-y-auto), fuellt also die gemeldete Hoehe
 * und scrollt den Inhalt intern. Bei Bedarf justieren.
 */
export const VARIO_IFRAME_HEIGHT = 900;

/**
 * Meldet die iframe-Hoehe an den Vario-Parent (feste Hoehe). Ohne das bleibt der
 * iframe auf Hoehe 0 zusammengeklappt und der Nutzer sieht ein leeres Panel.
 * Feuert initial + verzoegert nach (falls Vario den Slot erst nach dem ersten
 * Frame einrichtet) + bei resize.
 */
export function initVarioIframeHeight(height: number = VARIO_IFRAME_HEIGHT): void {
  const post = () => sendVarioMessage({ height });
  post();
  setTimeout(post, 300);
  setTimeout(post, 1500);
  window.addEventListener('resize', post);
}

/**
 * Fordert Vario zur Deinstallation auf und wartet auf die Bestaetigung
 * ({ uninstallState: true|false }). Fail-closed nach 30s.
 */
export function requestVarioUninstall(): Promise<boolean> {
  return new Promise((resolve) => {
    const listener = (e: MessageEvent) => {
      const data = e.data as { uninstallState?: boolean } | null;
      if (!data || typeof data !== 'object' || typeof data.uninstallState !== 'boolean') return;
      window.removeEventListener('message', listener);
      resolve(data.uninstallState);
    };
    window.addEventListener('message', listener);
    setTimeout(() => {
      window.removeEventListener('message', listener);
      resolve(false);
    }, 30_000);
    sendVarioMessage({ requestUninstall: true });
  });
}
